export const storeLocallyLastVisitedPage = (address) => {
  localStorage.setItem('lastVisitedPage', address);
};
